export const environment = {
    production: true,
    apiUrl: 'https://ofs2-dev-api.copago.io/api',
};
